import { render, staticRenderFns } from "./HumanBodyFrontMuscles.vue?vue&type=template&id=2a568cc2"
import script from "./HumanBodyFrontMuscles.vue?vue&type=script&lang=js"
export * from "./HumanBodyFrontMuscles.vue?vue&type=script&lang=js"
import style0 from "./HumanBodyFrontMuscles.vue?vue&type=style&index=0&id=2a568cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports